import { withInstall } from '@ll-plus/utils'

import EmailInput from './src/email-input.vue'

export const LlEmailInput = withInstall(EmailInput)

export * from './src/email-input'

declare module 'vue' {
  export interface GlobalComponents {
    LlEmailInput: typeof EmailInput
  }
}
